module.exports = __webpack_public_path__ + "static/media/sad.af79e757.svg";